import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
//import "./printOut/assets/billModal.css";
import { FaSearch, FaTrashAlt, FaPrint } from "react-icons/fa";
import { getLoginInfo } from '../utils/storage';
import { createNotification } from './Popup';
import AppManagementReusComponent from '../hooks/useApplicationManagement';
const AssessmentTable = ({ updateApplicationTable, appStatistics }) => {
  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const [isTableData, setIsTableData] = useState(false);
  const [applicationId, setApplicationId] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [appInfo, setAppInfo] = useState();
  const refreshPage = () => {};

  const pullApplication = async () => {
    setLoading(true);
    const payload = {
      ApplicationId: applicationId,
      UserName: getLoginInfo()?.user?.Username,
      StageId: "",
      Station: getLoginInfo()?.user?.StationID,
      Action: "Import",
      // AccessorId: getLoginInfo()?.user?.UserID,
    };

    const result = await handleApplicationManagement(
      payload,
      "application_management",
    );
    setLoading(false);
    if (result?.code == 1) {
      setAppInfo(result.data[0]);
      setIsTableData(true);
    } else {
      const info = { type: "error", message: result?.message };
      result?.data && createNotification(info)();
    }
  };

  const acceptApplication = async (applicationID) => {
    setLoading(true);
    const payload = {
      ApplicationId: applicationID,
      OperationType: "TAKE",
      UserName: getLoginInfo()?.user?.Username,
      Station: getLoginInfo()?.user?.StationID,
    };

    const result = await handleApplicationManagement(
      payload,
      "pull_management",
    );
    setLoading(false);
    if (result.code == 1) {
      updateApplicationTable();
      setIsTableData(false);
    } else {
      const info = { type: "error", message: result.message };
      createNotification(info)();
    }
  };

  const releaseApplication = () => {
    setIsTableData(false);
    setAppInfo(null);
  };

  const styles = {
    h4: {
      color: "#850505",
      textTransform: "uppercase",
    },
  };

  return (
    <div className="row2">
      <div className="col-md-12">
        <div className="card2">
          <div className="card-body4">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="column" style={{ backgroundColor: "#aaa;" }}>
                    <p>
                      <table>
                        <tr>
                          <td colSpan={5}>
                            <label className="control-label" for="FirstName">
                              <b style={{ color: "green" }}>
                                Receive Application:
                              </b>
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              type="text"
                              id="ApplicationID"
                              className="form-control"
                              name="ApplicationID"
                              aria-required="true"
                              placeholder="Application No."
                              style={{
                                color: "#850505",
                                fontSize: "1rem",
                                width: "320px",
                              }}
                              value={applicationId}
                              onChange={(e) => setApplicationId(e.target.value)}
                            />
                          </td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={() => pullApplication()}
                              name="submit"
                              style={{ height: "35px" }}
                            >
                              <b>
                                {loading ? (
                                  "Wait.."
                                ) : (
                                  <FaSearch style={{ fontSize: "15px" }} />
                                )}
                              </b>
                            </button>
                          </td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>
                            <button
                              type="clear"
                              className="btn btn-warning"
                              name="clear"
                              onClick={refreshPage}
                              style={{ height: "35px" }}
                            >
                              <b>
                                <FaTrashAlt style={{ fontSize: "15px" }} />
                              </b>
                            </button>
                          </td>
                          <td></td>
                        </tr>
                      </table>
                    </p>
                  </div>
                  <div>&nbsp;&nbsp;&nbsp;</div>
                  <div className="column" style={{ backgroundColor: "#bbb;" }}>
                    <p>
                      <table>
                        <label className="control-label" for="FirstName">
                          <b style={{ color: "green" }}>
                            <u>Application In-progres:</u>
                          </b>
                        </label>
                        <tr>
                          <td>Pending Assessment</td>
                          <td style={styles.h4}>
                            : | ( {appStatistics.TotalAssessmentLevel} )
                          </td>
                          &emsp;&emsp;
                          <td>Pending Approval</td>
                          <td style={styles.h4}>
                            : | ( {appStatistics.TotalApproveLevel} )
                          </td>
                        </tr>
                      </table>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isTableData && (
          <div className="card2">
            <div className="card-body">
              <div className="container">
                <table
                  id="myTable"
                  className="table table-striped table-bordered"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: "10%" }}>
                        <b>ApplicationID</b>
                      </th>
                      <th style={{ width: "27%" }}>
                        <b>Full Name</b>
                      </th>
                      <th style={{ width: "13%" }}>
                        <b>Application Type</b>
                      </th>
                      <th style={{ width: "18%" }}>
                        <b>Action</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <h4 style={styles.h4}>{appInfo?.ApplicationID}</h4>
                      </td>
                      <td>
                        <h4 style={styles.h4}>{appInfo?.FullName}</h4>
                      </td>
                      <td>
                        <h4 style={styles.h4}>
                          {appInfo?.ApplicationFromName}
                        </h4>
                      </td>

                      <td>
                        <button
                          type="submit"
                          className="btn btn btn btn-primary btn-sm"
                          name="ViewPass"
                          value="0002033"
                          onClick={() =>
                            acceptApplication(appInfo?.ApplicationID)
                          }
                        >
                          {loading ? "Wait.." : "Accept"}
                        </button>
                        &nbsp;||&nbsp;
                        <button
                          type="submit"
                          className="btn btn btn btn-danger btn-sm"
                          name="ViewPass"
                          value="0002033"
                          onClick={releaseApplication}
                        >
                          Release
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default AssessmentTable;
